<script setup lang="ts">
import { icons, type IconName } from './Icons/icons'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    name: IconName
    size?: string
    rotationDegree?: number
    classes?: string[]
  }>(),
  {
    size: '1rem',
    rotationDegree: 0,
    classes: () => [],
  }
)

const iconComponent = computed(() => {
  return icons[props.name]
})

const getRotationDegree = computed(() => {
  return props.rotationDegree ? `rotate(${props.rotationDegree}deg)` : 'none'
})
</script>

<template>
  <component
    :is="iconComponent"
    :class="[...classes]"
    :width="size"
    :style="{
      minWidth: size,
      width: size,
      transform: getRotationDegree,
    }"
    role="img"
    aria-hidden="true"
    class="fill-current transition-transform"
  />
</template>

<style lang="scss" scoped>
.fill-current.contacts-icon {
  fill: none;
}
</style>
